import {
    LOGIN,
    LOGIN_ERROR,
    LOGOUT,
    LOGOUT_ERROR,
    REFRESH,
    REFRESH_ERROR,
    VALIDATE_TOKEN,
    VALIDATE_TOKEN_ERROR,
    WAIT_FOR_TOKEN,
    GET_REPORTS_ERROR,
    GET_REPORTS, UPDATE_VALUES, UPDATE_VALUES_ERROR, UPLOAD_XML, GET_HOSPITAL, GET_HOSPITAL_ERROR,
    POST_REPORT, POST_REPORT_ERROR, DELETE_REPORT, DELETE_REPORT_ERROR, UPLOAD_XML_ERROR, CLEAR_BASIC_ERRORS

} from "./actions";
// import jwt_decode from 'jwt-decode';

export const waitForToken = (load) => async (dispatch) => {
    dispatch({
        type: WAIT_FOR_TOKEN,
        payload: load,
    });

};

// export const login = (credentials) => async (dispatch) => {
//     try {
//         const res = await fetch('http://localhost:8000/token/',
//             {
//                 method: "POST",
//                 headers: {
//                     'Content-Type': "application/json"
//                 },
//                 body: JSON.stringify(credentials)
//
//
//             });
//         waitForToken(false);
//         const status = await res.status;
//         const data = await res.json();
//         if (status !== 200) {
//             throw "Podane dane uwierzytelniające nie pozwalają na zalogowanie."
//         }
//         localStorage.setItem("JWT", data.token);
//
//
//         dispatch({
//             type: LOGIN,
//             payload: data.token,
//         });
//     } catch (err) {
//         console.error(err);
//         dispatch({
//             type: LOGIN_ERROR,
//             payload: err,
//         });
//     }
//
// };

// export const refreshToken = () => async (dispatch) => {
//     try {
//
//         dispatch({
//           type: SET_FILTER,
//           payload: filter_id,
//         });
//       } catch (err) {
//         dispatch({
//           type: GET_INDICATORS_ERROR,
//           payload: err.response.statusText,
//         });
//       }
//
// };


// export const validateToken = () => async (dispatch) => {
//     try {
//         const jwt = localStorage.getItem("JWT");
//         let data = null;
//         if (jwt === 'null' || jwt === null) {
//             data = {
//                 "expiryDate": null,
//                 "name": null,
//                 "jwt": null
//             }
//         } else {
//             let decodedToken = jwt_decode(jwt);
//             let currentDate = new Date();
//             if (decodedToken.exp * 1000 < currentDate.getTime()) {
//                 data = {
//                     "expiryDate": null,
//                     "name": null,
//                     "jwt": null,
//                     "err": "Sesja wygasła zaloguj się ponownie"
//                 };
//                 localStorage.removeItem("JWT")
//             } else {
//                 data = {
//                     "expiryDate": decodedToken.exp,
//                     "name": decodedToken.username,
//                     "jwt": jwt
//                 }
//             }
//
//
//         }
//         dispatch({
//             type: VALIDATE_TOKEN,
//             payload: data,
//         });
//     } catch (err) {
//         console.error(err);
//         dispatch({
//             type: VALIDATE_TOKEN_ERROR,
//             payload: err,
//         });
//     }
//
// };


// export const logout = () => async (dispatch) => {
//     try {
//
//         const jwt = localStorage.getItem("JWT");
//         let data = null;
//         if (jwt === 'null' || jwt === null) {
//             data = {
//                 "expiryDate": null,
//                 "name": null,
//                 "jwt": null
//             }
//         } else {
//             let decodedToken = jwt_decode(jwt);
//             let currentDate = new Date();
//             if (decodedToken.exp * 1000 < currentDate.getTime()) {
//                 data = {
//                     "expiryDate": null,
//                     "name": null,
//                     "jwt": null,
//                     "err": "Sesja wygasła zaloguj się ponownie"
//                 };
//                 localStorage.removeItem("JWT")
//             } else {
//                 data = {
//                     "expiryDate": decodedToken.exp,
//                     "name": decodedToken.username,
//                     "jwt": jwt
//                 }
//             }
//
//
//         }
//
//         dispatch({
//             type: LOGOUT,
//             payload: data,
//         });
//     } catch (err) {
//         console.error(err);
//         dispatch({
//             type: LOGOUT_ERROR,
//             payload: err,
//         });
//     }
//
// };

export const getReports = () => async (dispatch) => {
    try {
        let url =process.env.REACT_APP_GET_REPORTS
        const res = await fetch(url,
            {
                headers: {
                    'Content-Type': "application/json",
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },



            });
        const status = await res.status;
        const data = await res.json();
        if (status !== 200) {
            throw "Nie udało się pobrać listy sprawozdań."
        }

        dispatch({
            type: GET_REPORTS,
            payload: data,
        });
    } catch (err) {
        console.error(err);
        if(err instanceof SyntaxError)
            err = "Wystąpił nieoczekiwany Błąd, odśwież strone i spróbuj ponownie";
        dispatch({
            type: GET_REPORTS_ERROR,
            payload: err,
        });
    }

};

export const updateValues= (raport) => async (dispatch) => {
    try {
        //same url as get
        try{
            delete raport.file
        }
        catch(err){
            console.log("error: ", JSON.stringify(err))
        }
        let url =process.env.REACT_APP_GET_REPORTS + raport.id+"/";
        const res = await fetch(url,
            {

                method:"Put",
                headers: {
                    'Content-Type': "application/json",
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
                body:JSON.stringify(raport)


            });
            const status = await res.status;
        const data = await res.json();
        if (status !== 200) {
            throw "Nie udało się zmodyfikować sprawodzania."
        }

        dispatch({
            type: UPDATE_VALUES,
            payload: data,
        });
    } catch (err) {
        console.error(err);
        dispatch({
            type: UPDATE_VALUES_ERROR,
            payload: JSON.stringify(err),
        });
    }

};

export const uploadXML = (xml_file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("xml", xml_file);

    const url = process.env.REACT_APP_UPLOAD_XML;

    const res = await fetch(url, {
      method: "POST",
      headers: {
        'Authorization': 'JWT ' + localStorage.getItem("token")
      },
      body: formData,
    });

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    dispatch({
      type: UPLOAD_XML,
      payload: data,
    });
  } catch (err) {
    if (err instanceof SyntaxError) err = "Wystąpił nieoczekiwany błąd, odśwież stronę i spróbuj ponownie";

    dispatch({
      type: UPLOAD_XML_ERROR,
      payload: err?.error || err,
    });
  }
};


export const getHospital = ()=> async (dispatch) =>{
     try {
        const res = await fetch(process.env.REACT_APP_GET_HOSPITAL,
            {

                method:"GET",
                headers: {
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },


            });
        const status = await res.status;
        const data = await res.json(); //backedn returns list we want just 1 object
        if (status !== 200) {
            throw "Nie udało się pobrać szpitala."
        }

        dispatch({
            type: GET_HOSPITAL,
            payload: data[0],
        });
    } catch (err) {
        console.error(err);
                if(err instanceof SyntaxError)
            err = "Wystąpił nieoczekiwany Błąd, odśwież strone i spróbuj ponownie";
        dispatch({
            type: GET_HOSPITAL_ERROR,
            payload: err,
        });
    }




};



export const postReport= (raport) => async (dispatch) => {
    try {
        //same url as get

        let url =process.env.REACT_APP_GET_REPORTS
        const res = await fetch(url,
            {

                method:"POST",
                headers: {
                    'Content-Type': "application/json",
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },
                body:JSON.stringify(raport)


            });
        const status = await res.status;
        const data = await res.json();
        if (!res.ok) {
            throw res.error()
        }

        dispatch({
            type: POST_REPORT,
            payload: data,
        });
    } catch (err) {
        console.error(err);
        if(err instanceof SyntaxError)
            err = "Wystąpił nieoczekiwany Błąd, odśwież strone i spróbuj ponownie";
        dispatch({
            type: POST_REPORT_ERROR,
            payload: err,
        });
    }

};

export const deleteReport= (id) => async (dispatch) => {
    try {
        //same url as get

        let url =process.env.REACT_APP_GET_REPORTS+ id +"/"
        const res = await fetch(url,
            {

                method:"DELETE",
                headers: {
                    'Content-Type': "application/json",
                    'Authorization': 'JWT ' + localStorage.getItem("token")
                },



            });
        const status = await res.status;
        if (status !== 204) {
            throw "Nie udało się usunać sprawozdania"
        }

        dispatch({
            type: DELETE_REPORT,
            payload: id,
        });
    } catch (err) {
        console.error(err);
        if(err instanceof SyntaxError)
            err = "Wystąpił nieoczekiwany Błąd, odśwież strone i spróbuj ponownie";
        dispatch({
            type: DELETE_REPORT_ERROR,
            payload: err,
        });
    }

};

export const clearError= () => async (dispatch) => {
        dispatch({
            type: CLEAR_BASIC_ERRORS,
        });

};